export default "__VITE_ASSET__N74ogV7p__"